var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA4Defibrilator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73 10v5h-7v7h-5v-7h-7v-5h7V3h5v7h7zM62.42 37.5c0 16.59-19 29.23-28.82 34.31C23.76 66.73 4.78 54.09 4.78 37.5 4.78 28.76 11 21 20.56 21c6.37 0 10.15 2.54 13 7.36 2.88-4.82 6.67-7.36 13-7.36 9.62 0 15.86 7.76 15.86 16.5zM32.49 56.33L43.2 44H32.64l8.58-11h-5.07L24.89 47H36l-5.71 7.26L27 51.19V60h9.12l-3.63-3.67z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A4_Defibrilator.d76b4118.svg";
export { SvgA4Defibrilator as ReactComponent };